module.exports = __webpack_public_path__ + "static/media/MP4.1dde3a33.svg";